<template>
  <div>
    <vxe-grid
      size="mini"
      border
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:opt="{ row }">
        <el-tooltip
          effect="dark"
          :content="$l('btn_add') || '添加'"
          placement="top"
        >
          <i class="el-icon-check tool-btn" @click="add(row)" />
        </el-tooltip>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
    roleID: { type: String, default: '' },
  },
  data() {
    return {
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          align: 'center',
          fixed: 'left',
          width: 50,
          slots: { default: 'opt' },
        },
        {
          title: this.$l('table_label_userNo') || '用户账号',
          field: 'userNo',
          minWidth: 150,
          align: 'left',
          headerAlign: 'center',
        },
        {
          title: this.$l('table_label_userName') || '用户名称',
          field: 'userName',
          minWidth: 150,
          align: 'left',
          headerAlign: 'center',
          formatter: ({ row }) => {
            const { userName, userNameEn } = row
            return [userNameEn, userName].filter(Boolean).join('-')
          },
        },
      ],
    }
  },
  computed: {
    height() {
      const height = this.tableHeight - 250
      return height < 500 ? 500 : height
    },
  },
  methods: {
    async add({ userCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_auth') || '是否给该用户授予该权限？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .merchantRoleUserAddApi({ roleID: this.roleID, userCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_auth_no') || '授权失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_auth_ok') || '授权成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>
